import React, { useState } from 'react';
import { ListSearch } from './ListSearch';
import { FilterTag } from '../../model/filter';

export function ListSearchExample(): JSX.Element {
  const [query, setQuery] = useState<FilterTag[]>([
    { label: 'Krasserstoff', exclude: false },
    { label: 'Example', exclude: true },
    { label: 'Example2', exclude: false },
    { label: 'Example3', exclude: true },
    { label: 'Example4', exclude: true },
  ]);
  const [equery, setEQuery] = useState<FilterTag[]>([]);
  return (
    <>
      <ListSearch query={query} onChange={setQuery} loading={true} />
      <ListSearch query={equery} onChange={setEQuery} />
    </>
  );
}
